import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { useMediaQuery, Grid, Button, Typography, Avatar } from '@material-ui/core';
import ReactHtmlParser from 'react-html-parser';
import { SectionHeader } from 'components/molecules';

const useStyles = makeStyles(theme => ({
  price: {
    color: theme.palette.text.primary,
    fontSize: 32,
    fontWeight: 'normal',
    [theme.breakpoints.up('md')]: {
      fontSize: 48,
    },
  },
  disclimer: {
    borderRadius: theme.spacing(2),
    padding: theme.spacing(1 / 2, 1),
    background: theme.palette.alternate.main,
    display: 'inline-block',
  },
  image: {
    maxWidth: 600,
  },
  teamAvatar: {
    width: 250,
    height: 250,
    border: `${theme.spacing(1)}px solid ${theme.palette.background.paper}`,
    boxShadow: `0 2px 10px 0 ${theme.palette.cardShadow}`,
    marginTop: theme.spacing(1 / 2),
  },
}));

const Hero = props => {
  const { data, scrollTo, subscriable, className, ...rest } = props;
  const classes = useStyles();

  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <div className={className} {...rest}>
      <Grid
        container
        justifyContent="space-between"
        style={{'marginTop': '2em'}}
        spacing={isMd ? 4 : 2}
        direction={isMd ? 'row' : 'column-reverse'}
      >
        <Grid
          item
          container
          justifyContent="center"
          xs={12}
          md={6}
          data-aos={'fade-up'}
        >
          <Avatar
            {...{ src: data.avatarURL }}
            alt={data.name}
            className={classes.teamAvatar}
          />
        </Grid>
        <Grid item xs={12} md={6} data-aos={'fade-up'}>
          <SectionHeader
            title={data.name}
            subtitle={data.link}
            ctaGroup={ subscriable ? [
              <Button variant="contained" color="primary" size="large" onClick={e => {
                e.stopPropagation();
                scrollTo('SubscriptionSection');
              }}>
                Subscribe now
              </Button>,
            ] : []}
            align="left"
            data-aos="fade-up"
            titleVariant="h3"
          />
          <div className={classes.disclimer} data-aos="fade-up">
            <Typography variant="subtitle1" color="textSecondary">
              {ReactHtmlParser(data.bio)}
            </Typography>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

Hero.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
};

export default Hero;
